import combineReducers from "../utils/combineReducers";
import currentPageContextReducer from "./currentPageContextReducer";
import uiReducer from "./uiReducer";
import journeyReducer from "./journeyReducer";
import customerJourneyReducer from "./customerJourneyReducer";

export default combineReducers({
    currentPageContext: currentPageContextReducer,
    ui: uiReducer,
    jourenyInfo: journeyReducer,
    customerJourneyContext:customerJourneyReducer

})